import React from 'react';
import { doc, getDoc, updateDoc, Timestamp } from 'firebase/firestore';
import { db } from './firebaseConfig';
import './ApprovalCelebrationModal.css';

const ApprovalCelebrationModal = ({ approvedSuggestions, onDismiss }) => {
    const handleDismiss = async () => {
        // Mark as acknowledged in database
        const userId = localStorage.getItem('anonymousUserId');
        if (userId) {
            try {
                const userDocRef = doc(db, 'user_contributions', userId);
                const userDoc = await getDoc(userDocRef);

                if (userDoc.exists()) {
                    const contributions = userDoc.data().contributions || [];

                    // Mark all approved contributions as acknowledged
                    const updatedContributions = contributions.map((c, index) => {
                        if (c.status === 'approved' && c.type === 'location' && !c.acknowledgedAt) {
                            return { ...c, acknowledgedAt: Timestamp.now() };
                        }
                        return c;
                    });

                    await updateDoc(userDocRef, { contributions: updatedContributions });
                }
            } catch (error) {
                console.error('Error saving acknowledgment:', error);
            }
        }
        onDismiss();
    };

    // Get theme from document
    const theme = document.querySelector('[data-theme]')?.getAttribute('data-theme') || 'light';

    return (
        <div className="approval-modal-overlay" data-theme={theme}>
            <div className="approval-modal">
                <div className="approval-modal__icon">🎉</div>
                <h2 className="approval-modal__title">Suggestion Approuvée!</h2>
                <p className="approval-modal__message">
                    Votre suggestion d'emplacement pour <strong>{approvedSuggestions[0]?.rinkName}</strong> a été approuvée!
                </p>
                {approvedSuggestions.length > 1 && (
                    <p className="approval-modal__extra">
                        + {approvedSuggestions.length - 1} autre{approvedSuggestions.length > 2 ? 's' : ''} suggestion{approvedSuggestions.length > 2 ? 's' : ''} approuvée{approvedSuggestions.length > 2 ? 's' : ''}
                    </p>
                )}
                <button className="approval-modal__button" onClick={handleDismiss}>
                    🎊 Yay!
                </button>
            </div>
        </div>
    );
};

export default ApprovalCelebrationModal;
